import React from "react";
import styled from "@emotion/styled";
import { useRemark } from "react-remark";

const RewardTitle = styled.p`
  width: 100%;
  margin: 0;
  font-weight: bold;
  font-size: 36px;
  line-height: 44px;
  text-align: left;
`;

const RewardDescription = styled.p`
  width: 100%;
  margin: 10px 0 20px;
  font-size: 20px;
  color: #666;
  text-align: left;
`;

const RewardContent = styled.div`
  margin: 10px 0 20px;
  color: #333;

  p,
  li {
    font-size: 20px;
    line-height: 34px;
  }

  h1 {
    font-size: 30px;
  }

  blockquote,
  pre {
    margin: 0 0 20px;
    padding: 10px 30px;
    border: 1px solid #f1f1f1;
    border-radius: 5px;
    background: #fbf9f9;
    overflow: auto;
  }

  table {
    width: 100%;
    border: 1px solid #f1f1f1;
    border-radius: 5px;
    background: #fbf9f9;

    th,
    td {
      text-align: left;
      padding: 5px 10px;
      border-bottom: 1px solid #f1f1f1;
      border-right: 1px solid #f1f1f1;

      &:last-of-type {
        border-right: none;
      }
    }

    tr:last-of-type td {
      border-bottom: none;
    }
  }

  img {
    width: 100%;
  }
`;

const RewardAmount = styled.p`
  width: 100%;
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  color: #666;
`;

const typeLabels: Record<string, string> = {
  "discord-role": "Cargo no Discord",
  "telegram-channel": "Grupo no Telegram",
  "campaign-coupon": "Código",
};

type Props = {
  type: string;
  title: string;
  description: string;
  content: string;
  triggers: string[];
  amount: number;
};

const formatAmount = (amount: number) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(amount);

export default function RewardView(props: Props) {
  const [reactContent, setMarkdownSource] = useRemark();

  React.useEffect(() => {
    setMarkdownSource(props.content);
  }, [setMarkdownSource, props.content]);

  return (
    <>
      <RewardAmount>
        {typeLabels[props.type]} por {formatAmount(props.amount)} ou mais
      </RewardAmount>
      <RewardTitle>{props.title}</RewardTitle>
      <RewardDescription>{props.description}</RewardDescription>
      <RewardContent>{reactContent}</RewardContent>
    </>
  );
}
